import { useState, useEffect } from "react";
import axios from "axios";

export default function usePost(blog_id, user, token) {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/posts/${blog_id}`,
          { params: { userId: user?._id } }
        );
        setPost(res.data);
      } catch (error) {
        console.error("Error fetching post:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPost();
  }, [blog_id, user]);

  const deletePost = async () => {
    await axios.delete(
      `${process.env.REACT_APP_API_URL}/api/posts/${post._id}`,
      {
        data: { userId: user._id },
        headers: { Authorization: `Bearer ${token}` },
      }
    );
  };

  const updatePost = async (updated) => {
    await axios.put(
      `${process.env.REACT_APP_API_URL}/api/posts/${post._id}`,
      updated,
      { headers: { Authorization: `Bearer ${token}` } }
    );
  };

  return { post, setPost, loading, deletePost, updatePost };
}
